import { render, staticRenderFns } from "./UpsertMgidCampaignForm.vue?vue&type=template&id=53ba57dc&"
import script from "./UpsertMgidCampaignForm.vue?vue&type=script&lang=js&"
export * from "./UpsertMgidCampaignForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports